import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles()(() => ({
  chips: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    gap: 16,
    columnGap: 8,
  },
}));

export type QChoiceChipsProps<Item> = {
  disabled?: boolean;
  items: Item[];
  labelFromItem?: (item: Item) => string;
  keyFromItem?: (item: Item) => React.Key;
  defaultSelectedItems?: Item[];
  selectedItems?: Item[];
  onSelected: (items: Item[]) => void;
  multiple?: boolean;
  rootClass?: any;
};
export default function QChoiceChips<Item>(props: QChoiceChipsProps<Item>) {
  const { classes, cx } = useStyles();
  const {
    disabled,
    items,
    labelFromItem,
    keyFromItem,
    defaultSelectedItems,
    selectedItems,
    onSelected,
    multiple,
    rootClass,
  } = props;
  const theme = useTheme();
  const [selectedItemsState, setSelectedItemsState] = useState<Item[]>(defaultSelectedItems || selectedItems || []);
  const selected = defaultSelectedItems ? selectedItemsState : selectedItems ?? [];

  return (
    <div sharedcomponentid={'Q_CHOICE_CHIPS'} className={cx(classes.chips, rootClass)}>
      {items.map((item) => (
        <Chip
          key={keyFromItem ? keyFromItem(item) : String(item)}
          id={keyFromItem ? String(keyFromItem(item)) : String(item)}
          label={labelFromItem ? labelFromItem(item) : String(item)}
          clickable
          disabled={disabled}
          onClick={() => {
            let newSelectedItems = selected;
            if (selected?.includes(item)) {
              // remove
              if (multiple) {
                newSelectedItems = selected.filter((existingItem) => existingItem !== item);
              }
            } else if (multiple) {
              newSelectedItems = [...(selected || []), item];
            } else {
              newSelectedItems = [item];
            }
            setSelectedItemsState(newSelectedItems);
            onSelected(newSelectedItems);
          }}
          variant='outlined'
          className={selected.includes(item) ? 'MuiChip-selected' : ''}
          sx={{
            backgroundColor: selected.includes(item) ? theme.palette.primary.light : theme.palette.background.default,
            color: selected.includes(item) ? theme.palette.primary.main : theme.palette.text.primary,
            border: 'none',
          }}
        />
      ))}
    </div>
  );
}
